import type { components } from '@shared/api/generated/admin-v1'

export type MediaAsset = components['schemas']['MediaAsset']
export type MediaPage = components['schemas']['MediaPage']
export type MediaFilePolicy = components['schemas']['MediaFilePolicy']
export type MediaKind = MediaAsset['kind']
export type MediaState = MediaAsset['state']
export type MediaKindPolicy = components['schemas']['MediaKindPolicy']

export const mediaKeys = {
	all: ['media'] as const,
	policy: ['media', 'policy'] as const,
	list: (filters: unknown) => ['media', 'list', filters] as const,
	detail: (id: string) => ['media', 'detail', id] as const,
}

export const mediaKindLabel: Record<MediaKind, string> = {
	IMAGE: 'Изображение',
	VIDEO: 'Видео',
	ICON: 'Иконка',
	SVG_MASK: 'SVG-маска',
}

export const mediaStateLabel: Record<MediaState, string> = {
	CREATED: 'Создан',
	UPLOADING: 'Загрузка',
	UPLOADED: 'Загружен',
	PROCESSING: 'Обработка',
	READY: 'Готов',
	REJECTED: 'Отклонён',
	DELETING: 'Ожидает удаления',
	DELETED: 'Удалён',
}

export const terminalMediaStates = new Set<MediaState>(['READY', 'REJECTED', 'DELETING', 'DELETED'])
